'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _some = require('lodash/some');

var _some2 = _interopRequireDefault(_some);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _applicationState = require('../../../utils/applicationState');

var _adSlotManager = require('../../adSlotManager');

var _adSlotManager2 = _interopRequireDefault(_adSlotManager);

var _logger = require('../../../logging/logger');

var _logger2 = _interopRequireDefault(_logger);

var _reporter = require('../../reporter');

var _reporter2 = _interopRequireDefault(_reporter);

var _palSdkController = require('../../../targeting/palSdkController');

var _palSdkController2 = _interopRequireDefault(_palSdkController);

var _CompanionAdManager = require('../../media/companions/CompanionAdManager');

var _CompanionAdManager2 = _interopRequireDefault(_CompanionAdManager);

var _CompanionCache = require('../../media/companions/CompanionCache');

var _CompanionCache2 = _interopRequireDefault(_CompanionCache);

var _companionEvents = require('../../media/companions/companionEvents');

var _companionEvents2 = _interopRequireDefault(_companionEvents);

var _constants = require('../../../utils/constants');

var _constants2 = require('../../../logging/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
  the ad units are hard coded because they are only used for internal logging,
*/
var devAdUnitIds = {
  side: '15480783/Dev.Gemini/dev.instream_banner_side',
  top: '15480783/Dev.Gemini/dev.instream_banner_top',
  audio: '15480783/Dev.Gemini/dev.instream_audio'
};

var prodAdUnitIds = {
  side: '15480783/Gemini/instream_banner_side',
  top: '15480783/Gemini/instream_banner_top',
  audio: '15480783/Gemini/instream_audio'
};

var InstreamCompanionController = function InstreamCompanionController() {
  var _this = this;

  _classCallCheck(this, InstreamCompanionController);

  this.destroy = function () {
    if (_this.companionAdManager) {
      _this.companionAdManager.off(_companionEvents2.default.loaded, _this.onCompanionLoaded);
      _this.companionAdManager.off(_companionEvents2.default.clicked, _this.onCompanionAdClick);
    }

    _this.resetCompanionsIfNeeded();
  };

  this.set = function (property, value) {
    _this[property] = value;
  };

  this.resetCompanionsIfNeeded = function () {
    if (_this.companionModelSlots.length < 1) {
      return;
    }

    _logger2.default.debug('resetCompanionsIfNeeded');
    (0, _forEach2.default)(_this.companionModelSlots, function (slot) {
      var displaySlot = _adSlotManager2.default.getSlot(slot.elementId);
      if (displaySlot) {
        displaySlot.refresh();
      }
    });

    _this.companionModelSlots = [];
  };

  this.refreshUnusedSlots = function (companions, displaySlots) {
    (0, _forEach2.default)(displaySlots, function (slot) {
      var slotWidth = (0, _get2.default)(slot, 'currentDimensions[0]');
      var slotHeight = (0, _get2.default)(slot, 'currentDimensions[1]');

      var hasNewCompanion = (0, _some2.default)(companions, function (c) {
        return slotWidth === c.width && slotHeight === c.height;
      });

      // if the displayslot exists in the companions, do nothing - allow it to be replaced
      // if it doesn't, then refresh it
      if (!hasNewCompanion) {
        slot.refresh();
      }
    });
  };

  this.mapCompanionData = function (companionAdData) {
    return companionAdData.map(function (companion) {
      var trackingEvent = (0, _find2.default)(companion.trackingEvents, function (te) {
        return te.eventType === 'creativeView';
      });
      var trackingPixel = (0, _get2.default)(trackingEvent, 'beaconUrls[0]', '');
      return {
        width: (0, _get2.default)(companion, 'attributes.width'),
        height: (0, _get2.default)(companion, 'attributes.height'),
        content: {
          isInstream: true,
          staticResource: companion.staticResource, // static image
          htmlResource: companion.htmlResource, // iframe ad
          companionClickThrough: companion.companionClickThrough, // static ad destination
          companionClickTracking: companion.companionClickTracking, // on click of static ad
          trackingPixel: trackingPixel // tracking for staticResource, doesn't exist for htmlResource
        }
      };
    });
  };

  this.handleCompanionAds = function (ad) {
    var companionAds = ad.companionAds;


    if (companionAds.length < 1) {
      _logger2.default.debug('There are no companions for this ad.');

      // TUNE-11882 hardcoding adProvider to `dfp` for instream ads without companion ads
      _this.adProvider = _constants.Networks.dfp;

      // clear companions from previous instream ad
      _this.resetCompanionsIfNeeded();
      return;
    }

    var displaySlots = _adSlotManager2.default.getDisplaySlots();

    var adProvider = (0, _get2.default)(displaySlots, '[0].formatDefinition.adProvider');
    if (!adProvider) {
      _this.adProvider = 'unknown';
      return;
    }
    _this.adProvider = adProvider;
    var companions = _this.mapCompanionData(companionAds);

    if (_this.companionModelSlots.length > companionAds.length) {
      _this.refreshUnusedSlots(companions, displaySlots);
    }

    _this.companionModelSlots = [];
    try {
      _this.companionAdManager.processCompanionAds(companions, displaySlots, adProvider);
    } catch (ex) {
      _logger2.default.error({
        message: _constants2.INSTREAM_AD_COMPANION_ERROR,
        error: ex,
        data: _reporter2.default.getParameters(_this.audioSlotData)
      });
    }
  };

  this.onCompanionLoaded = function (companionSlot) {
    if (!companionSlot) {
      return;
    }

    _this.companionModelSlots.push(companionSlot);
  };

  this.onCompanionAdClick = function (slot) {
    if (!slot) {
      return;
    }

    var instreamSlotData = _this.getInstreamSlotData(slot);
    _reporter2.default.click(instreamSlotData);
    _palSdkController2.default.reportAdClick();
    _logger2.default.info({
      message: _constants2.INSTREAM_COMPANION_AD_CLICKED,
      data: _reporter2.default.getParameters(instreamSlotData)
    });
  };

  this.showCompanionAds = function () {
    if (_this.companionModelSlots.length < 1) {
      return;
    }

    (0, _forEach2.default)(_this.companionModelSlots, function (companionSlot) {
      return _this.showCompanionAd(companionSlot);
    });
  };

  this.showCompanionAd = function (companionSlotModel) {
    var elementId = companionSlotModel.elementId,
        name = companionSlotModel.name,
        format = companionSlotModel.format,
        width = companionSlotModel.width,
        height = companionSlotModel.height,
        content = companionSlotModel.content;


    if (!elementId || !name || !format || !width || !height || !content) {
      return;
    }

    var mintSlot = _adSlotManager2.default.getSlot(elementId); // display slot
    if (!mintSlot) {
      return;
    }

    var slotElement = global.document.getElementById(elementId);
    if (!slotElement) {
      return;
    }

    // set requestId to ensure it is included and that it doesn't conflict with a previous ad
    mintSlot.requestId = _this.currentAdRequestId;
    mintSlot.formatDefinition = format;
    mintSlot.currentDimensions = [width, height];

    try {
      if (mintSlot.adTypeController) {
        mintSlot.adTypeController.deregisterSlot(mintSlot);
        mintSlot.adTypeController.releaseSlot(mintSlot);
      }

      _this.companionAdManager.renderCompanionAd(slotElement, mintSlot, width, height, content);
      _adSlotManager2.default.addCompanionSlot(mintSlot);

      var slotData = _this.getInstreamSlotData(mintSlot);

      _reporter2.default.impression(slotData);
      _logger2.default.debug('Instream Companion Ad Rendered/Impression.');
    } catch (ex) {
      var _slotData = _this.getInstreamSlotData(companionSlotModel);
      _logger2.default.error({
        message: _constants2.INSTREAM_AD_COMPANION_ERROR,
        error: ex,
        data: _reporter2.default.getParameters(_slotData)
      });
    }
  };

  this.getDisplayUnitId = function (slot) {
    var slotName = slot.name || '';
    if (slotName.indexOf('top') > -1) {
      return _this.adUnitIds.top;
    }
    if (slotName.indexOf('side') > -1) {
      return _this.adUnitIds.side;
    }
    return 'instream_unknown';
  };

  this.getInstreamSlotData = function (slot) {
    var slotUnitId = _this.getDisplayUnitId(slot);

    return _extends({}, slot, {
      formatDefinition: {
        adProvider: _this.adProvider,
        adUnitId: slotUnitId
      }
    });
  };

  this.audioSlotData = {};
  this.currentAdRequestId = '';
  this.companionModelSlots = [];

  this.companionAdManager = new _CompanionAdManager2.default(new _CompanionCache2.default());
  this.companionAdManager.on(_companionEvents2.default.loaded, this.onCompanionLoaded);
  this.companionAdManager.on(_companionEvents2.default.clicked, this.onCompanionAdClick);

  var env = (0, _applicationState.getState)(_applicationState.State.env);
  this.adUnitIds = env === 'production' ? prodAdUnitIds : devAdUnitIds;
}

// This is for the case when one ad in the adBreak has two companions and the
// next ad has only one. The display slot that's not replaced needs to be
// refreshed or it gets stuck on the old ad
;

exports.default = InstreamCompanionController;